var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.category)?_c('v-icon',_vm._b({attrs:{"color":_vm.forceColor ? _vm.forceColor : _vm.color}},'v-icon',_vm.$attrs,false),[_vm._v("\n  "+_vm._s(_vm.icon)+"\n")]):_c('v-icon',_vm._b({},'v-icon',_vm.$attrs,false),[_vm._v(_vm._s(_vm.icon))])}
var staticRenderFns = []

export { render, staticRenderFns }